import {
  ActionType,
  Actions,
  ApplicationContextDispatch,
  ApplicationContextState,
  Brand,
  ContextOptions,
  Team,
} from '../applicationContext.types';

export const loadingBrands = () => ({
  type: Actions.LOADING_BRANDS,
});

export const setUser = (user: Team) => ({
  type: Actions.SET_USER,
  payload: { user },
});

export const setAdminTeceo = () => ({
  type: Actions.SET_ADMIN_TECEO,
});

export const setBrand = (brand: Brand | undefined) => ({
  type: Actions.SET_BRAND,
  payload: { brand },
});

export const loadContext = (context: Partial<ApplicationContextState>): ActionType => ({
  type: Actions.LOAD_CONTEXT,
  payload: context,
});

export const configureContext = (options: Partial<ContextOptions>): ActionType => ({
  type: Actions.CONFIGURE_CONTEXT,
  payload: { options },
});

export const hideContactBrandFloatButton = () => ({
  type: Actions.HIDE_CONTACT_BRAND_FLOAT_BUTTON,
});

export const resetContactBrandFloatButtonState = () => ({
  type: Actions.RESET_CONTACT_BRAND_FLOAT_BUTTON_STATE,
});

export const resetToDefaultOptions = (dispatch: ApplicationContextDispatch) => {
  dispatch(configureContext({ disableBrand: false, showBrand: true }));
};
